<template>
    <div v-if="mostrar"
        class="flex-row-fluid d-flex flex-center justfiy-content-xl-first"
        id="contenedorNoticias"
    >
        <div class="shadow-sm p-lg-16" style="width: 100%">
            <div class="text-center mb-5">
                <h1
                    class="text-blue mb-13"
                    style="font-size: 1.9rem !important"
                >
                    Noticias Melón
                </h1>
                <div class="container" id="Noticias-list">
                    <Carousel
                        :autoplay="100000"
                        :wrap-around="true"
                        :settings="settings"
                        :breakpoints="breakpoints"
                        :key="key"
                    >
                        <Slide
                            class=""
                            v-for="(item, grupoIndex) in items"
                            :key="grupoIndex"
                        >
                            <div class="card w-100">
                                <img
                                    :src="item.data"
                                    class="card-img-top imagen-noticia"
                                    alt="..."
                                />
                                <div class="card-body">
                                    <h5 class="card-title">
                                        {{ item.nombre }}
                                    </h5>
                                    <p class="card-text">{{ item.noticia }}</p>
                                    <div class="d-flex justify-content-end">
                                        <a
                                            class="more"
                                            @click="abrir(item)"
                                            target="_blank"
                                        >
                                            Leer Más
                                            <svg
                                                class="ms-2"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="17"
                                                height="10"
                                                viewBox="0 0 17 10"
                                                fill="none"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.7014 0.724947C11.9736 0.429168 12.4195 0.424467 12.6972 0.714446L16.2888 4.46445C16.4239 4.6055 16.5 4.79851 16.5 5C16.5 5.20149 16.4239 5.3945 16.2888 5.53555L12.6972 9.28555C12.4195 9.57553 11.9736 9.57083 11.7014 9.27505C11.4291 8.97927 11.4335 8.50442 11.7112 8.21444L14.7898 5L11.7112 1.78555C11.4335 1.49558 11.4291 1.02073 11.7014 0.724947Z"
                                                    fill="#006C90"
                                                />
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M0.5 5C0.5 4.72386 0.85913 4.5 1.30214 4.5H14.6979C15.1409 4.5 15.5 4.72386 15.5 5C15.5 5.27614 15.1409 5.5 14.6979 5.5H1.30214C0.85913 5.5 0.5 5.27614 0.5 5Z"
                                                    fill="#006C90"
                                                />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Slide>

                        <template #addons>
                            <Navigation />
                            <Pagination />
                        </template>
                    </Carousel>
                </div>

                <a class="btn btn-melon btn-ayuda" v-if="false">
                    <svg
                        class="me-5"
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 56 56"
                        fill="none"
                    >
                        <path
                            d="M27.86 44.8C28.84 44.8 29.6688 44.4612 30.3464 43.7836C31.024 43.106 31.3619 42.2781 31.36 41.3C31.36 40.32 31.0221 39.4912 30.3464 38.8136C29.6707 38.136 28.8419 37.7981 27.86 37.8C26.88 37.8 26.0521 38.1388 25.3764 38.8164C24.7007 39.494 24.3619 40.3219 24.36 41.3C24.36 42.28 24.6988 43.1088 25.3764 43.7864C26.054 44.464 26.8819 44.8019 27.86 44.8ZM25.34 34.02H30.52C30.52 32.48 30.6955 31.2667 31.0464 30.38C31.3973 29.4933 32.3885 28.28 34.02 26.74C35.2333 25.5267 36.19 24.3712 36.89 23.2736C37.59 22.176 37.94 20.8581 37.94 19.32C37.94 16.7067 36.9833 14.7 35.07 13.3C33.1567 11.9 30.8933 11.2 28.28 11.2C25.62 11.2 23.4612 11.9 21.8036 13.3C20.146 14.7 18.9915 16.38 18.34 18.34L22.96 20.16C23.1933 19.32 23.7188 18.41 24.5364 17.43C25.354 16.45 26.6019 15.96 28.28 15.96C29.7733 15.96 30.8933 16.3688 31.64 17.1864C32.3867 18.004 32.76 18.9019 32.76 19.88C32.76 20.8133 32.48 21.6888 31.92 22.5064C31.36 23.324 30.66 24.0819 29.82 24.78C27.7667 26.6 26.5067 27.9767 26.04 28.91C25.5733 29.8433 25.34 31.5467 25.34 34.02ZM28 56C24.1267 56 20.4867 55.2645 17.08 53.7936C13.6733 52.3227 10.71 50.3281 8.19 47.81C5.67 45.29 3.67547 42.3267 2.2064 38.92C0.737334 35.5133 0.00186667 31.8733 0 28C0 24.1267 0.735467 20.4867 2.2064 17.08C3.67733 13.6733 5.67187 10.71 8.19 8.19C10.71 5.67 13.6733 3.67547 17.08 2.2064C20.4867 0.737334 24.1267 0.00186667 28 0C31.8733 0 35.5133 0.735467 38.92 2.2064C42.3267 3.67733 45.29 5.67187 47.81 8.19C50.33 10.71 52.3255 13.6733 53.7964 17.08C55.2673 20.4867 56.0019 24.1267 56 28C56 31.8733 55.2645 35.5133 53.7936 38.92C52.3227 42.3267 50.3281 45.29 47.81 47.81C45.29 50.33 42.3267 52.3255 38.92 53.7964C35.5133 55.2673 31.8733 56.0019 28 56ZM28 50.4C34.2533 50.4 39.55 48.23 43.89 43.89C48.23 39.55 50.4 34.2533 50.4 28C50.4 21.7467 48.23 16.45 43.89 12.11C39.55 7.77 34.2533 5.6 28 5.6C21.7467 5.6 16.45 7.77 12.11 12.11C7.77 16.45 5.6 21.7467 5.6 28C5.6 34.2533 7.77 39.55 12.11 43.89C16.45 48.23 21.7467 50.4 28 50.4Z"
                            fill="white"
                        />
                    </svg>
                </a>

                <div class="btn-contacto" @click="Ayuda = true">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 56 56"
                        fill="none"
                    >
                        <path
                            d="M27.86 44.8C28.84 44.8 29.6688 44.4612 30.3464 43.7836C31.024 43.106 31.3619 42.2781 31.36 41.3C31.36 40.32 31.0221 39.4912 30.3464 38.8136C29.6707 38.136 28.8419 37.7981 27.86 37.8C26.88 37.8 26.0521 38.1388 25.3764 38.8164C24.7007 39.494 24.3619 40.3219 24.36 41.3C24.36 42.28 24.6988 43.1088 25.3764 43.7864C26.054 44.464 26.8819 44.8019 27.86 44.8ZM25.34 34.02H30.52C30.52 32.48 30.6955 31.2667 31.0464 30.38C31.3973 29.4933 32.3885 28.28 34.02 26.74C35.2333 25.5267 36.19 24.3712 36.89 23.2736C37.59 22.176 37.94 20.8581 37.94 19.32C37.94 16.7067 36.9833 14.7 35.07 13.3C33.1567 11.9 30.8933 11.2 28.28 11.2C25.62 11.2 23.4612 11.9 21.8036 13.3C20.146 14.7 18.9915 16.38 18.34 18.34L22.96 20.16C23.1933 19.32 23.7188 18.41 24.5364 17.43C25.354 16.45 26.6019 15.96 28.28 15.96C29.7733 15.96 30.8933 16.3688 31.64 17.1864C32.3867 18.004 32.76 18.9019 32.76 19.88C32.76 20.8133 32.48 21.6888 31.92 22.5064C31.36 23.324 30.66 24.0819 29.82 24.78C27.7667 26.6 26.5067 27.9767 26.04 28.91C25.5733 29.8433 25.34 31.5467 25.34 34.02ZM28 56C24.1267 56 20.4867 55.2645 17.08 53.7936C13.6733 52.3227 10.71 50.3281 8.19 47.81C5.67 45.29 3.67547 42.3267 2.2064 38.92C0.737334 35.5133 0.00186667 31.8733 0 28C0 24.1267 0.735467 20.4867 2.2064 17.08C3.67733 13.6733 5.67187 10.71 8.19 8.19C10.71 5.67 13.6733 3.67547 17.08 2.2064C20.4867 0.737334 24.1267 0.00186667 28 0C31.8733 0 35.5133 0.735467 38.92 2.2064C42.3267 3.67733 45.29 5.67187 47.81 8.19C50.33 10.71 52.3255 13.6733 53.7964 17.08C55.2673 20.4867 56.0019 24.1267 56 28C56 31.8733 55.2645 35.5133 53.7936 38.92C52.3227 42.3267 50.3281 45.29 47.81 47.81C45.29 50.33 42.3267 52.3255 38.92 53.7964C35.5133 55.2673 31.8733 56.0019 28 56ZM28 50.4C34.2533 50.4 39.55 48.23 43.89 43.89C48.23 39.55 50.4 34.2533 50.4 28C50.4 21.7467 48.23 16.45 43.89 12.11C39.55 7.77 34.2533 5.6 28 5.6C21.7467 5.6 16.45 7.77 12.11 12.11C7.77 16.45 5.6 21.7467 5.6 28C5.6 34.2533 7.77 39.55 12.11 43.89C16.45 48.23 21.7467 50.4 28 50.4Z"
                            fill="white"
                        />
                    </svg>
                    <span>¿Dudas o Consultas?</span>
                </div>
            </div>
        </div>
    </div>

    <p style="display: none" id="titulo">{{ nombre }}</p>
    <p style="display: none" id="noticia">{{ noticia }}</p>
    <p style="display: none" id="img">{{ img }}</p>
    <viewNoticia v-if="abrirNoticia" @cancelar="abrirNoticia = false">
    </viewNoticia>

    <Ayuda
        v-if="Ayuda"
        @cancelar="Ayuda = false"
        @guardarAyuda="guardarAyuda"
    ></Ayuda>

    <!--Modal Error-->
    <transition name="fade">
        <div class="modal-overlay" v-if="showModalError">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p
                            class="modal-title header-error"
                            id="exampleModalLabel"
                        >
                            ERROR
                        </p>
                        <button
                            type="button"
                            class="closeModel"
                            data-dismiss="modal"
                            aria-label="Cerrar"
                            @click="showModalError = false"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                            >
                                <circle cx="15" cy="15" r="15" fill="#006C90" />
                                <path
                                    d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{ mensajeError }}</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-error"
                            @click="showModalError = false"
                        >
                            Aceptar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <!--Modal Exito-->
    <transition name="fade">
        <div class="modal-overlay" v-if="showModalExito">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title" id="exampleModalLabel">
                            Felicitaciones!!!
                        </p>
                        <button
                            type="button"
                            class="closeModel"
                            data-dismiss="modal"
                            aria-label="Cerrar"
                            @click="showModalExito = false"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                            >
                                <circle cx="15" cy="15" r="15" fill="#006C90" />
                                <path
                                    d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{ mensajeExito }}</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-guardar"
                            @click="showModalExito = false"
                        >
                            Aceptar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { Actions } from "@/store/enums/StoreEnums";
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import viewNoticia from "./viewNoticia.vue";
import Ayuda from "@/components/noticias/Ayuda.vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import router from "@/router";
export default {
    name: "Noticias",
    components: {
        viewNoticia,
        Carousel,
        Slide,
        Pagination,
        Navigation,
        Ayuda,
    },
    setup() {
        const items = ref([]);
        const store = useStore();
        const mostrar = ref(true);
        const key = ref(0);
        const settings = ref({
            itemsToShow: 1,
            snapAlign: "center",
        });
        const breakpoints = ref({
            700: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            1024: {
                itemsToShow: 3,
                snapAlign: "center",
            },
        });

        const splitToNChunks = (array, n) => {
            let result = [];
            let aux = [];
            let cont = n;
            for (let i = 0; i < array.length; i++) {
                if (cont <= n && cont > 0) {
                    aux.push(array[i]);
                    cont--;

                    if (cont <= 0 || i == array.length - 1) {
                        cont = n;
                        result.push(aux.copyWithin());
                        aux = [];
                    }
                }
            }
            return result;
        };

        const fetchItems = async () => {
            try {
                var data = await store.dispatch(Actions.GET_NOTICIAS);
                let documentos = [];
                if (data != null) {
                    await data.noticias.forEach((item) => {
                        var base64 = "";
                        const extension = item.imagen
                            .toLowerCase()
                            .split(".")[1];
                        if (
                            extension === "png" ||
                            extension === "jpg" ||
                            extension === "jpeg"
                        ) {
                            base64 = `data:image/${extension};base64,${item.data}`;
                        }

                        documentos.push({
                            codigo: item.codigo,
                            nombre: item.nombre,
                            noticia: item.noticia,
                            imagen: item.imagen,
                            id: item.id,
                            data: base64,
                            activo: false,
                        });
                    });
                }

                if (documentos.length == 0) {
                    mostrar.value = false
                }

                if (documentos.length == 1) {
                    breakpoints.value[700].itemsToShow = 1;
                    breakpoints.value[1024].itemsToShow = 1;
                    key.value += 1;
                }

                if (documentos.length == 2) {
                    breakpoints.value[700].itemsToShow = 2;
                    breakpoints.value[1024].itemsToShow = 2;
                    key.value += 1;
                }

                items.value = documentos;
            } catch (error) {
                console.log(error);
            }
        };

        onMounted(async () => {
            await fetchItems();
        });
        return {
            items,
            splitToNChunks,
            settings,
            breakpoints,
            key,
            mostrar
        };
    },
    data() {
        return {
            store: useStore(),
            abrirNoticia: false,
            nombre: "",
            noticia: "",
            img: "",
            Ayuda: false,
            showModalError: false,
            mensajeError: "",
            showModalExito: false,
            mensajeExito: "",
        };
    },
    mounted() {
        document.addEventListener("slid.bs.carousel", this.updateActiveIndexes);
    },
    methods: {
        async guardarAyuda(files) {
            if (files == null) {
                this.mensajeError =
                    "No fue posible crear la solicitud. Intenta nuevamente.";
                this.showModalError = true;
                this.Ayuda = false;
            } else {
                this.mensajeExito =
                    "La solicitud se creó de manera correcta. \n\r Pronto nos comunicaremos contigo.";
                this.showModalExito = true;
                this.Ayuda = false;
            }
        },
        abrir(item) {
            router.push({ name: "noticia", params: { id: item.id } });
        },
    },
};
</script>

<style scoped>
.btn-contacto,
.btn-contacto-xs {
    width: 48px;
    height: 148px;
    padding: 8px 0;
    margin: 0;
    background: #fe5300;
    border-bottom-left-radius: 8px;
    cursor: pointer;
    transition: 0.3s;
    position: fixed;
    top: 50%;
    bottom: 0;
    right: 0;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.btn-contacto svg {
    /* position: absolute;
  bottom: 0; */
    position: relative;
}
.btn-contacto span,
.btn-contacto-xs span {
    font-size: 10px;
    width: 100%;
    min-width: 90px;
    margin-top: 35px;
    display: block;
    color: #fff;
    font-weight: 700;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    text-align: center;
    position: relative;
    transform: rotate(-90deg);
}
.btn-ayuda {
    padding: 10px 50px !important;
    color: #fff;
    position: fixed;
    right: 0;
    top: 50%;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.text-blue {
    color: #006c90;
    font-size: 1.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

#contenedorNoticias {
    background: #fff;
}

.card-head {
    display: inline-grid;
    justify-items: end;
}

.card-head svg {
    padding-top: 12px;
    padding-right: 9px;
}

.card .card-body {
    padding: 0.5rem 1.25rem;
    text-align: initial;
}

.card-title {
    margin-bottom: 21px;
    margin-top: 21px;
    text-align: initial;
    color: #006c90;
    font-size: 1rem;
    font-weight: 700;
    line-height: normal;

    text-overflow: ellipsis;
    overflow: hidden;

    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical !important;
}

.btn-participar {
    border-radius: 50px;
    background: #006c90;
    width: 180px;
    height: 38px;
    color: #fff;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.parametro {
    color: #a3a3a3;
    font-size: 0.8rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.dato {
    color: #a3a3a3;
    font-size: 0.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.parametroHasta {
    padding: 0px;
    margin-bottom: 1.5rem;
}

.parametroUbi {
    margin-bottom: 1.5rem;
}

.parametroFecha {
    margin-bottom: 0.7rem;
}

.container-participar {
    align-items: center;
    display: flex;
    justify-content: center;
}

.selector.active {
    background: #006c90;
}

.selector {
    border: 0px;
    background: #fff;
}

.carousel-indicators {
    padding-top: 3%;
    top: 100%;
}

.mostrarIzquierda {
    display: block !important;
}

.mostrarDerecha {
    display: block !important;
}

.active,
.mostrarDerecha,
.mostrarIzquierda {
    max-width: 33.3% !important;
    margin-right: 0% !important;
    display: flex !important;
    justify-content: center;
}

.imagen-noticia {
    max-height: 409px;
    min-height: 350px;
    height: 10.5rem;
    object-fit: cover;
}

.card {
    border-radius: 10px;
    border: 1px solid #ebebeb;
    background: #fff;
    min-height: 510px;
    max-height: 530px;
}

.card-text {
    text-overflow: ellipsis;
    overflow: hidden;
    /* color: #006C90; */
    color: #333;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: justify;
    margin-bottom: 20px;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical !important;
}

.selector {
    background: rgb(104 104 104);
}

#Noticias-list {
    margin-bottom: 10rem;
}

.more {
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: right;
    color: #333;
    font-family: Roboto;
    font-size: 13px;
    cursor: pointer;
}

.help {
    color: #fff;
    width: auto;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 6rem;
    position: absolute;
    right: 0;
}

.help a {
    border-radius: 50px;
    background: #006c90;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
}

.modal-footer {
    padding: 0px 1.5rem 1.5rem 0px !important;
    border: 0px !important;
}

.btn-guardar {
    display: flex;
    width: 120px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.btn-error {
    color: white;
    background-color: red;
}
</style>
